'use client';

import { useEffect, useId, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './testimonials.css';

const testimonials = {
  aroma: {
    organization: "L’aroma d’Isara", author: 'M-P NOLBAS', role: '',
    image: '/assets/testimonials/aroma-isara.png',
    excerpt: 'Leurs experts se sont imprégnés de mon activité',
    quote: "RDV-Partners m'a permis d'offrir des services très personnalisés à mes clients. Leur plateforme est innovante et pointue, associée à un accompagnement très personnalisé, ce qui est unique. Leurs experts se sont imprégnés de mon activité pour m'aider à exploiter tout son potentiel. Merci pour ce travail remarquable. !",
  },
  douanes: {
    organization: 'Douanes & Droits indirects', author: 'E. GARCIA', role: 'CHEF PAE',
    image: '/assets/testimonials/douanes.png',
    excerpt: '10/10 sur la simplification, l’ergonomie et les facilités d’utilisation',
    quote: "Votre plateforme mérite un 10/10 sur la simplification, l'ergonomie et les facilités d'utilisation. D'autant plus, que notre projet a dû se monter en quelques heures seulement. Très bonne réactivité.",
  },
  arianespace: {
    organization: 'Arianespace', author: 'JP BARLET', role: 'ARIANESPACE Evry DIO / OW',
    image: '/assets/testimonials/arianespace.webp',
    excerpt: 'Votre professionnalisme et votre méthode font une réelle différence.',
    quote: 'Nous sommes en train de lancer une constellation de satellites à un rythme intense ...\nVotre professionnalisme et votre méthode font une réelle différence.\nNous avons bien progressé !',
  },
} as const;
type TestimonialId = keyof typeof testimonials;

function Quote({ id }: { id: TestimonialId }) {
  const item = testimonials[id];
  return <figure className="rdv-testimonial" lang="fr">
    <div className="rdv-testimonial-brand"><img src={item.image} alt={item.organization} width={160} height={90} loading="lazy" /></div>
    <div className="rdv-testimonial-copy">
      <blockquote><p>« {item.quote} »</p></blockquote>
      <figcaption><strong>{item.author}</strong><span>{item.role || item.organization}</span></figcaption>
    </div>
  </figure>;
}

export default function Testimonials({ ids }: { ids: TestimonialId[] }) {
  const heading = useId();
  return <section className="rdv-testimonials" aria-labelledby={heading} lang="fr">
    <h2 id={heading}>Leur expérience avec RDV-Partners</h2>
    <div className={'rdv-testimonials-grid' + (ids.length > 1 ? ' rdv-testimonials-pair' : '')}>
      {ids.map(id => <Quote key={id} id={id} />)}
    </div>
  </section>;
}

export function HomeTestimonials() {
  const [selected, setSelected] = useState<TestimonialId | null>(null);
  const dialog = useRef<HTMLDialogElement>(null);
  const trigger = useRef<HTMLButtonElement | null>(null);
  const title = useId();
  useEffect(() => {
    if (!selected) return;
    const element = dialog.current;
    element?.showModal();
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { element?.close(); document.body.style.overflow = previous; queueMicrotask(() => trigger.current?.focus({ preventScroll: true })); };
  }, [selected]);
  return <>
    <aside className="rdv-testimonial-home" aria-label="Leur expérience avec RDV-Partners" lang="fr">
      <p className="rdv-testimonial-home-heading">Leur expérience avec RDV-Partners</p>
      <div className="rdv-testimonial-home-list">
        {(Object.keys(testimonials) as TestimonialId[]).map(id => <button key={id} type="button" onClick={event => { trigger.current = event.currentTarget; setSelected(id); }} aria-haspopup="dialog" aria-label={'Lire le témoignage de ' + testimonials[id].organization}>
          <img src={testimonials[id].image} alt="" width={72} height={42} />
          <span>« {testimonials[id].excerpt} »</span><span aria-hidden="true">↗</span>
        </button>)}
      </div>
    </aside>
    {selected && createPortal(<dialog ref={dialog} className="rdv-testimonial-dialog" aria-labelledby={title} lang="fr" onCancel={() => setSelected(null)} onClose={() => setSelected(null)} onClick={event => { if (event.target === event.currentTarget) setSelected(null); }}>
      <div className="rdv-testimonial-dialog-inner">
        <div className="rdv-testimonial-dialog-heading"><h2 id={title}>Leur expérience avec RDV-Partners</h2><button type="button" autoFocus onClick={() => setSelected(null)} aria-label="Fermer le témoignage">×</button></div>
        <Quote id={selected} />
      </div>
    </dialog>, document.body)}
  </>;
}
